export class CommandManager {
  constructor(onChange = () => {}) {
    this.undoStack = []
    this.redoStack = []
    this.onChange = onChange
  }

  execute(command) {
    command.do()
    this.undoStack.push(command)
    this.redoStack = []
    this.onChange()
  }

  undo() {
    const command = this.undoStack.pop()
    if (!command) return false
    command.undo()
    this.redoStack.push(command)
    this.onChange()
    return true
  }

  redo() {
    const command = this.redoStack.pop()
    if (!command) return false
    command.do()
    this.undoStack.push(command)
    this.onChange()
    return true
  }
}

export class CommandRegistry {
  constructor() { this.commands = new Map() }
  register(command) { this.commands.set(command.id, command) }
  getAll() { return [...this.commands.values()] }
  run(id) { const command = this.commands.get(id); if (command) command.execute() }
}
